RivalIQ.module('export.data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    data.actions = new Backbone.Collection([
        {
            id: RivalIQ.export.type.EMAIL,
            name: 'Email',
            icon: 'fa-envelope-o',
            description: 'Delivered via email'
        },
        {
            id: RivalIQ.export.type.DOWNLOAD,
            name: 'Download',
            icon: 'fa-download',
            description: 'Delivered via direct download'
        },
        {
            id: RivalIQ.export.type.SCHEDULE,
            name: 'Schedule',
            icon: 'fa-clock-o',
            description: 'Scheduled Report'
        }
    ]);
});
